import type { U3141ChildLotChain } from '../U3141Service';

/**
 * Détermine si un child lot chain est orphelin (aucune concordance entrante ni sortante)
 * et n'est pas le lot principal du registre.
 */
export function u3141IsOrphanChildLotChain(childLotChain: U3141ChildLotChain, requestedLot: string): boolean {
  const { concordance, concordanceOrigines, lot } = childLotChain.lotDetail ?? {};
  const noOutgoing = !concordance?.some((entry) => typeof entry === 'string' && entry.trim().length > 0);
  const noIncoming = !concordanceOrigines?.some((entry) => typeof entry === 'string' && entry.trim().length > 0);
  const notMain = lot?.trim() !== requestedLot?.trim();
  return noOutgoing && noIncoming && notMain;
}
